import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'next-i18next';
import { compose } from 'redux';

import RoundedButton from 'src/shared/components/RoundedButton';

import styles from './styles.module.scss';

const SubmitButton = (props) => {
    const { t, id, containerClassName, className, label, loading, disable, onSubmit } = props;

    const onClick = () => {
        if (loading) {
            return;
        }
        onSubmit();
    };

    return (
        <div className={`${containerClassName} ${styles.container}`}>
            <RoundedButton
                id={id}
                className={`${className} ${styles.buttonContainer}`}
                type="tertiary-on-dark"
                loading={loading}
                disable={disable}
                onClick={onClick}
            >
                {label || t('submit_button')}
            </RoundedButton>
        </div>
    );
};

SubmitButton.defaultProps = {
    id: '',
    label: '',
    containerClassName: '',
    className: '',
    loading: false,
    disable: false,
};

SubmitButton.propTypes = {
    id: PropTypes.string,
    label: PropTypes.string,
    containerClassName: PropTypes.string,
    className: PropTypes.string,
    loading: PropTypes.bool,
    disable: PropTypes.bool,
    onSubmit: PropTypes.func.isRequired,
};

export default compose(withTranslation())(SubmitButton);
